// extracted by mini-css-extract-plugin
export var container = "FriendlyCaptcha-module--container--9e6cc";